"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constants = require("./constants");

var _default = {
  PropTypes: {
    type: _propTypes.default.string,
    open: _propTypes.default.bool,
    zIndex: _propTypes.default.number,
    children: _propTypes.default.node.isRequired,
    theme: _propTypes.default.string,
    background: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    customProperties: _propTypes.default.object,
    customPropertiesTray: _propTypes.default.object,
    onTrayBlur: _propTypes.default.func
  },
  DefaultProps: {
    type: _constants.DEVICE_TYPE.DESKTOP,
    open: _constants.OPEN,
    onTrayBlur: function onTrayBlur() {},
    zIndex: _constants.ZINDEX,
    children: _constants.TEXT,
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;